import React, { useState } from 'react';
import { Button, Row, Col } from 'antd';

import { getFullName } from 'utils/personUtils';
import BaseAlert from 'components/wrappers/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import BasePageCard from 'components/wrappers/BasePageCard';
import { ProfileCorporateInfoModel } from 'api/backofficeApiClient';
import { getCorporateTABillingInformation } from 'redux/reducers/recruiterSlice';
import BaseSectionMessage from 'components/wrappers/BaseSectionMessage';
import EditBillingInfoModal from 'features/account/AdditionalInfo/BillingInfo/EditBillingInfoModal';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  corporateInfo?: ProfileCorporateInfoModel;
};

export default function BillingInfoSection(props: Props) {
  const { corporateInfo } = props;
  const dispatch = useAppDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [billingInfo, setBillingInfo] = useState(corporateInfo?.billingInfo);
  const billingInfoName = getFullName(
    billingInfo?.firstName,
    billingInfo?.lastName,
  );

  const loadBillingInfo = async () => {
    const result = await dispatch(
      getCorporateTABillingInformation(corporateInfo?.companyId),
    );

    if (getCorporateTABillingInformation.fulfilled.match(result)) {
      setBillingInfo(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  return (
    <>
      {isModalVisible && (
        <EditBillingInfoModal
          companyId={corporateInfo?.companyId}
          onEdit={loadBillingInfo}
          billingInfo={billingInfo}
          onClose={() => setIsModalVisible(false)}
        />
      )}

      <BasePageCard
        title="Billing information"
        className="stretch-card"
        icons={<span className="icon icon-invoice"></span>}
        subTitle={
          <Button
            onClick={() => setIsModalVisible(true)}
            className="with-icon mobile-icon-only"
            size="large"
            icon={<span className="icon icon-edit" />}
          >
            Edit
          </Button>
        }
      >
        <div className="content-wrapper scroll-box">
          {!billingInfo && (
            <BaseSectionMessage
              type="info"
              title="Info"
              message={
                <span>
                  Waiting for member to respond. Billing information will be
                  displayed after a member enters the data.
                </span>
              }
            />
          )}

          {!!billingInfo && (
            <Row gutter={[4, 4]} className="titled-sheet">
              {!!billingInfoName && (
                <Col xs={24} md={12}>
                  <div className="title">A/P:</div>
                  <div>{billingInfoName}</div>
                </Col>
              )}

              {!!billingInfo.email && (
                <Col xs={24} md={12}>
                  <div className="title">A/P email:</div>
                  <div>{billingInfo.email}</div>
                </Col>
              )}

              {!!billingInfo.phoneNumber && (
                <Col xs={24} md={12}>
                  <div className="title">A/P phone number:</div>
                  <div>{billingInfo.phoneNumber}</div>
                </Col>
              )}
            </Row>
          )}
        </div>
      </BasePageCard>
    </>
  );
}
